import '../grouped_elements/grouped_elements_filter_view.js.coffee'
Namespace 'Monitoring.Views.SocialContents.Filters.GroupedElements'

class Monitoring.Views.SocialContents.Filters.TagsFilterView extends Monitoring.Views.SocialContents.Filters.GroupedElementsFilterView
  name: 'tags'
  facetName: 'tag'
  selectAll: true
  alias: 'Intelligent Tag'
  className: 'tag-filter'

  initialize: (@options = {}) ->
    super(@options)
    @facet_tags = @facet[@facetName]
    @terms = _.sortBy(_.clone(@facet_tags['terms']), (term) => @getDescription(term).toLowerCase())

  getGroupsLogic: () ->
    'first_group_elements':    @searchQuery.get(@withPrefix('primary_tags_logic')),
    'second_group_elements':   @searchQuery.get(@withPrefix('secondary_tags_logic')),
    'excluded_group_elements': @searchQuery.get(@withPrefix('excluded_tags_logic'))

  getGroupsElements: () ->
    first_group_elements: @withPrefix('primary_tags')
    second_group_elements: @withPrefix('secondary_tags')
    excluded_group_elements: @withPrefix('excluded_tags')

  viewFor: (viewId) =>
    new Monitoring.Views.SocialContents.Filters.TagsFilterGroupView(@optionsFor(viewId))

  titles: ->
    first_group_elements: I18n.t('monitoring.taxonomy.first_group_elements')
    second_group_elements: I18n.t('monitoring.taxonomy.second_group_elements')
    excluded_group_elements: I18n.t('monitoring.taxonomy.excluded_group_elements')

  onApply: =>
    @searchQuery.set(@withPrefix('primary_tags'), _.pluck(@firstGroupView.appliedElements, 'term'))
    @searchQuery.set(@withPrefix('primary_tags_logic'), @firstGroupView.logic)
    @searchQuery.set(@withPrefix('secondary_tags'), _.pluck(@secondGroupView.appliedElements, 'term'))
    @searchQuery.set(@withPrefix('secondary_tags_logic'), @secondGroupView.logic)
    @searchQuery.set(@withPrefix('excluded_tags'), _.pluck(@excludedGroupView.appliedElements, 'term'))
    @searchQuery.set(@withPrefix('excluded_tags_logic'), @excludedGroupView.logic)
    @_triggerQueryChanged()

  _triggerQueryChanged: =>
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  _generateAllElements: (terms)->
    tags = []
    for term, description of @tagsByClientCode
      facet = _.find(terms, (node) -> node.term == term)
      if facet
        count = facet.count
      else
        count = 0
      hidden = Keepcon.hiddenTags && Keepcon.hiddenTags[term] == true
      tags.push({ term: term, description: description, count: count , hidden: hidden , custom: false}) unless hidden
    return tags

  getName: () ->
    'tags'

  isEmpty: ->
    false

  _noValuesDescription: ->
    I18n.t('customer.dashboard.filters.creation.tags.no_tags')

  _allValuesDescription: ->
    I18n.t('customer.dashboard.filters.creation.tags.any_tag')
